import React, { useState } from "react";
import InputField from "./InputField";
import Button from "./Button";
import useTicket from "../hooks/useTicket";
import { ticketAtom } from "../store";
import { useAtom } from "jotai";
import { validateInput } from "../utils";
import { useNavigate } from "react-router-dom";

const Idheading = () => {
  const [data, ] = useAtom(ticketAtom);
  const [ticketId, setTicketId] = useState("");
  const [ email, setEmail ] = useState("");
  const { loading } = useTicket();
  const navigate = useNavigate()

  
  const handleRouteChange = () => {
    if(email && ticketId) {
      navigate(`/tracking/?ticketID=${ticketId}&email=${email}`)
    }
  }

  const handleChange = (val: string) => {
    return validateInput(val, () => setTicketId(val));
  };

  const changeRouteOnEnterKey = (e:React.KeyboardEvent<HTMLInputElement>) => {
    if(e.key==="Enter"){
      if (email && ticketId) {
        navigate(`/tracking/?ticketID=${ticketId}&email=${email}`);
      }
    }
  }

  return (
    <>
      <section className="ti-content-container">
        <div className="ticket-id-sect">
          <div className="tv-bx-1">
            <p>TICKET ID - {data?.ticket_id}</p>
          </div>

          <div className="tv-bx-2">
            <InputField
            name="email"
            type={'text'}
            placeholder='Enter Email'
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
            onKeyDown={(e)=>changeRouteOnEnterKey(e)}
             />
            <p>and</p>
            <InputField
              name="ticket-id"
              type="text"
              id="ticket-id"
              placeholder="Enter your ticket ID"
              value={ticketId}
              onChange={(e) => handleChange(e.target.value)}
              onKeyDown={(e)=>changeRouteOnEnterKey(e)}
            />
            <Button
              onClick={handleRouteChange}
              disabled={(!ticketId || ticketId === "") || (!email || email === "")}
            >
              {loading ? "Tracking..." : "Track"}
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Idheading;
